const constant = {
  UAT: 'uat',
  PREPROD: 'preprod',
  PROD: 'prod'
}

export default constant